<div class="notifications-shell" ngbDropdown #dropdown="ngbDropdown" placement="bottom-end" [autoClose]="'outside'" (openChange)="onDropdownOpenChange($event)">
  <button
    type="button"
    id="notificationsDropdown"
    class="notifications-trigger"
    [class.notifications-trigger-open]="dropdown.isOpen()"
    [class.notifications-trigger-disabled]="disabled"
    [disabled]="disabled"
    ngbDropdownToggle
    [attr.aria-label]="'Notifications' | translate">
    <span class="notifications-icon-wrap">
      <nb-icon [icon]="dropdown.isOpen() ? 'bell' : 'bell-outline'"></nb-icon>
      <span *ngIf="notification_count > 0" class="notifications-badge">
        {{ notification_count > 99 ? '99+' : notification_count }}
      </span>
    </span>
  </button>

  <div
    aria-labelledby="notificationsDropdown"
    class="notifications-popover"
    [ngClass]="{ 'rtl': language.isArabic }"
    ngbDropdownMenu>
    <div class="notifications-header">
      <div>
        <p class="notifications-eyebrow">{{ 'Active Alerts' | translate }}</p>
        <h6>{{ 'Notifications' | translate }}</h6>
      </div>
    </div>

    <div class="notifications-list" (scroll)="onScroll($event)">
      <div *ngFor="let notification of notifications" class="notification-card-row">
        <app-notifications-card
          [notification]="notification"
          [isGridView]="false"
          [notificationsType]="getNotificationType(notification)"
          (closeNotifications)="dropdown.close()">
        </app-notifications-card>
      </div>

      <div *ngIf="loading" class="notifications-loading">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      </div>
    </div>

    <div *ngIf="!loading && notifications.length < 1" class="notifications-empty">
      <nb-icon icon="bell-outline"></nb-icon>
      <p>{{ 'There are no new notifications' | translate }}</p>
    </div>
  </div>
</div>
